<template>

  <b-container fluid class="w-100  menu-container">

    <b-tabs content-class="mt-3 p-0 w-100" align="center"
            active-nav-item-class="font-weight-bold bg-warning custom-active-class" nav-class="primary-bg ">

      <b-tab class="w-100 mt-2" @click="filterFoods('')">
        <template #title>
          <b-row class="d-flex flex-row justify-content-center m-0 p-0 tab-title-container">
            <b-col class="d-flex flex-column align-items-center justify-content-center p-0 m-0">
              <img class="food-tab-image" :alt="findAttributeOnSiteInfo('site_name')[0]"
                   :src="defaultCategoryImage"/>
              <h5>آخرین غذاها</h5>
            </b-col>
          </b-row>
        </template>

        <div class="container">
          <b-card class="m-3 food-list-card" v-for="food in foods" :key="food.id">
            <m-c16 :route-to-food="foodLink" :food="food" :basket="basket">
              <template #comment>
                <b-button class="food-comment-btn mt-1 col-lg-8  border-0" v-b-toggle.food-comments pill
                          @click="getFoodComment(food.id, food.name)">نظرات
                </b-button>
              </template>
            </m-c16>
          </b-card>

          <b-row class="d-flex flex-row justify-content-center p-0 pt-3 m-0 w-100">
            <m-pagination-400 :meta="meta" :on-change-page="changePage"/>
          </b-row>
        </div>

      </b-tab>

      <b-tab :id="`active_tab_${category.id}`" class="w-100 mt-2" @click="filterFoods(category.id)"
             v-for="category in categories" :key="category.id" v-if="category.products_count !== 0">

        <template #title>
          <b-row class="d-flex flex-row justify-content-center m-0 p-0 tab-title-container">
            <b-col class="d-flex flex-column align-items-center justify-content-center p-0 m-0">
              <img :alt="category.name" class="food-tab-image" :src="categoryThumbnail(category)"/>
              <h5>{{ category.name }}</h5>
            </b-col>
          </b-row>
        </template>

        <b-container>
          <b-card class="m-3 food-list-card" v-for="food in foods" :key="food.id">
            <m-c16 :route-to-food="foodLink" :food="food" :basket="basket">
              <template #comment>
                <b-button class="food-comment-btn mt-1 col-lg-8  border-0" v-b-toggle.food-comments pill
                          @click="getFoodComment(food.id, food.name)">نظرات
                </b-button>
              </template>
            </m-c16>

          </b-card>

          <b-row class="d-flex flex-row justify-content-center p-0 pt-3 m-0 w-100">
            <m-pagination-400 :meta="meta" :on-change-page="changePage"/>
          </b-row>
        </b-container>

      </b-tab>

    </b-tabs>

    <product-comment :comments="comments" :food_id="food_id" :food_name="food_name"/>

  </b-container>

</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter"
import ProductComment from "./ProductComment";

export default {
  name: "Products301",
  props: {
    foodLink: {
      default: false
    },
    defaultCategoryImage: {
      default: ''
    }
  },
  components: {ProductComment},
  data() {
    return {
      tabIndex: 0,
      food_id: '',
      food_name: ''
    }
  },
  computed: {
    ...mapGetters({
      foods: "Product/getProducts",
      categories: "Category/getCategories",
      meta: "Product/getPaginationMeta",
      basket: "ShoppingCart/getSidebarBasketData",
      comments: 'Comment/getProductComments'
    }),
  },
  methods: {
    getFoodComment(foodId, foodName) {
      this.food_id = foodId
      this.food_name = foodName
      let form = {id: foodId, comment_type: 'product'}
      this.$store.dispatch("Comment/getClientComments", {form: form})

    },
    filterFoods(category) {
      if (category === '') {
        this.$store.commit('Product/setFilters', {key: 'category', value: []})
        this.$store.dispatch("Product/setProducts")
      } else {
        this.$store.commit('Product/setFilters', {key: 'category', value: [category]})
        this.$store.dispatch("Product/setProducts", 1)
      }

      this.$router.push({name: this.$route.name, query: {category: category}})
      this.$route.query.category = category
      this.setActiveTab(category)
    },
    formatNumber,
    changePage(page) {
      this.$store.dispatch("Product/setProducts", page)
      const route_name = this.$route.name

      this.$router.push({name: route_name, query: {page: page, ...this.$route.query}})
    },
    categoryThumbnail(category) {
      return category.image == null ? this.defaultCategoryImage : category.image
    },
    setActiveTab(category) {
      document.querySelectorAll('.custom-active-class').forEach(function (item) {
        item.classList.remove('font-weight-bold')
        item.classList.remove('bg-warning')
        item.classList.remove('custom-active-class')
        item.classList.remove('active')
      })

      document.getElementById(`active_tab_${category}___BV_tab_button__`).classList.add('font-weight-bold')
      document.getElementById(`active_tab_${category}___BV_tab_button__`).classList.add('bg-warning')
      document.getElementById(`active_tab_${category}___BV_tab_button__`).classList.add('custom-active-class')
      document.getElementById(`active_tab_${category}___BV_tab_button__`).classList.add('active')
    }
  },
  async mounted() {

    if (this.$route.params.slug != undefined) {
      await this.$store.dispatch("Category/getCategories")
      await this.$store.dispatch("Brand/getBrandFilters", this.$route.params.slug)

      this.$store.dispatch("Brand/showBrand", {slug: this.$route.params.slug}
      ).then(res => {
        this.restaurant = res.data.data


        let page = 1;
        if (this.$route.query.page) {
          page = this.$route.query.page
        }


        this.$store.commit('Product/setFilters', {key: 'brand', value: [this.restaurant.id]})

        this.$store.dispatch("Product/setProducts", page)

      })

    } else {
      await this.$store.dispatch("Category/getCategories")
      let page = 1;
      if (this.$route.query.page) {
        page = this.$route.query.page
      }

      let category = [];
      if (this.$route.query.category) {
        category.push(this.$route.query.category)
      }

      await this.$store.commit('Product/setFilters', {key: 'category', value: category})
      await this.$store.dispatch("Product/setProducts", page)
    }


  },
  async updated() {
    await this.setActiveTab(this.$route.query.category)
  }
};
</script>


<style>
.food-list-card .card-body {
  padding: 0 !important;
}

.nav-link.active {
  background: var(--light-primary) !important;
  color: var(--secondary) !important;
}

.nav-link {
  margin-top: 10px;
}

.nav-tabs .nav-link:focus {
  background: var(--light-primary) !important;
  color: var(--secondary) !important;
}

</style>

<style scoped>

.tab-title-container {
  color: var(--secondary);
  font-weight: bold;
}

.tab-title-container:focus {
  outline: none;
  background: var(--light-primary);
}


.food-tab-image {
  width: 80px;
  position: relative;
  top: -10px;
}

</style>